<template>
  <section id="app" class="section">
    <router-view></router-view>
  </section>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss" scoped>
.section {
  padding: 20px 0 0;
}
</style>